import { getFirebaseAuth } from "@/lib/firebase/client";
import { getAppCheckHeader } from "@/lib/firebase/appCheck";

type NotifyInput = {
  userIds: string[];
  title: string;
  body?: string;
  url?: string;
  /**
   * Action buttons w notyfikacji (Android/desktop natywne).
   * iOS PWA z home-screen IGNORUJE actions — pokazuje tylko body
   * i tap = otwiera URL. Dlatego flow musi też działać bez akcji.
   */
  actions?: Array<{ action: string; title: string }>;
  /**
   * Dodatkowe pola payload.data (string-string). Czytane przez SW
   * w notificationclick — np. {completionId: "abc"} pozwala routować
   * tap na akcję na konkretny URL z parametrami.
   */
  data?: Record<string, string>;
  /**
   * Gdy true — backend doliczy aktualną liczbę pending completions w
   * household i wstrzykuje do `data.badge`. SW po stronie odbiorcy
   * ustawi tym `setAppBadge` na ikonie home-screen (iOS PWA / Android
   * Chrome PWA / desktop dock). Używaj na akcjach które zmieniają
   * liczbę pending — submit completion (parent +1), approve/reject
   * (parent -1).
   */
  badgeFromPending?: boolean;
};

const FUNCTION_BASE =
  import.meta.env.VITE_FUNCTIONS_BASE_URL ||
  "https://europe-central2-kidsduty-53b67.cloudfunctions.net";

/**
 * Wysyła push do podanych userIds przez Firebase Function.
 * Best-effort: błędy tylko logowane.
 */
export async function notifyUsers(input: NotifyInput): Promise<void> {
  if (input.userIds.length === 0) return;
  try {
    const user = getFirebaseAuth().currentUser;
    if (!user) return;
    const token = await user.getIdToken();
    const appCheck = await getAppCheckHeader();
    const res = await fetch(`${FUNCTION_BASE}/pushSend`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        ...appCheck,
      },
      body: JSON.stringify(input),
    });
    if (!res.ok) {
      console.warn("notifyUsers failed", res.status, await res.text());
    }
  } catch (e) {
    console.warn("notifyUsers exception", e);
  }
}
